import configs from "./endpoints";

export default configs;
